<template>
    <div>{{ range }}</div>
</template>

<script>
export default {
    name: "PageRange",
    props: {
        totalCount: {
            type: Number,
            required: true
        },

        currentPage: {
            type: Number,
            required: true
        },

        pageLength: {
            type: Number,
            required: true
        },
    },

    computed: {
        hasNextPage() {
            return this.currentPage <= Math.floor(this.totalCount / this.pageLength)
        },

        range() {
            let range = ""
            // First page
            if (this.currentPage == 1) {
                if (this.totalCount == 0) {
                    range = "0"
                } else if (this.totalCount < this.pageLength) {
                    // When the number of items in the first page is less than the page length
                    range = "1 - " + this.totalCount
                } else {
                    // When the number of items in the first page is greater or equals to the page length
                    range = "1 - " + this.pageLength
                }
            } else if (this.hasNextPage) {
                // Between the first and last page
                range = this.pageLength * (this.currentPage - 1) + 1 + " - " + this.pageLength * this.currentPage
            } else {
                // Last page
                const startRange = this.pageLength * (this.currentPage - 1) + 1
                const endRange = this.totalCount

                // When user provided an invalid page number
                if (startRange > endRange) {
                    this.$emit('isInvalidPageNumber', true)
                }
                range = this.pageLength * (this.currentPage - 1) + 1 + " - " + this.totalCount
            }
            return range + " of " + this.totalCount
        }
    },
}
</script>
